import HeroSlider from './HeroSlider'
import CelestialWheel from './CelestialWheel'
import './HeroSection.css'

export default function HeroSection() {
  return (
    <header className="relative min-h-[110vh] lg:min-h-screen w-full flex items-center justify-center z-10 pb-24 lg:pt-36 lg:pb-16 overflow-hidden bg-[#160F0A]">
      <div className="max-w-7xl 2xl:max-w-400 mx-auto w-full grid grid-cols-1 lg:grid-cols-12 px-5 items-center relative">
        <div className="lg:col-span-6 flex flex-col justify-center space-y-7 md:space-y-9 text-center lg:text-left order-2 lg:order-1 relative z-10">
          <HeroSlider />
        </div>

        <CelestialWheel />
      </div>
    </header>
  )
}
